<template>
  <router-link :to="{ name: 'magideiShiurTorah', params: { slug: magidShiur.url_key } }">
    <div class="d-flex no-gutters align-items-center">
      <!--      <b-img-lazy blank-src="/static/blank_profile.jpg" :src="imgsrc" fluid class="width50px" />-->
      <span class="col pl-2">
        <strong>{{ magidShiur.name }}</strong>
      </span>
    </div>
  </router-link>
</template>
<script>
export default {
  props: ['magidShiur', 'type'],
  computed: {
    // imgsrc: function() {
    //   return this.magidShiur.image.name !== null ? this.magidShiur.image_url : '/static/blank_profile.jpg';
    // },
  },
};
</script>
<style>
.width50px {
  width: 50px;
}
</style>
